import {management} from '../../../index'
import { FarmRepository } from '../../infra/knex/repositories/farmsRepository'
import { SectorHasFarmRepository } from '../../infra/knex/repositories/sector_has_farm'

import {CreateFarmUseCase} from './createFarmUseCase'
import { DeleteFarmByIdUseCase } from './deleteFarmByIdUseCase'
import { ShowFarmByIdUseCase } from './showFarmByIdUseCase'
import { ShowFarmUseCase } from './showFarmUseCase'
import { UpdateFarmByIdUseCase } from './updateFarmUseCase'
import { GetSectorsWithFarmsSectorUseCase } from './getSectorsWithFarms'
import { UpdateFkEditorUseCase } from './updateFkEditorUseCase'
import { GetFarmIdByNameUseCase } from './getFarmIdByNameUseCase'
import { UpdateFarmTimeByIdUseCase } from './updateFarmTimeUseCase'

export const farmUseCase=()=>{
  const repository= new FarmRepository(management)
  const sectorHasFarmRepository= new SectorHasFarmRepository(management)

  const add=new CreateFarmUseCase(repository)
  const show=new ShowFarmUseCase(repository)
  const showFarmByIdUseCase=new ShowFarmByIdUseCase(repository)
  const del= new DeleteFarmByIdUseCase(repository)
  const edit= new UpdateFarmByIdUseCase(repository)
  const updateFkEditor = new UpdateFkEditorUseCase(repository)
  const getFarmIdByName = new GetFarmIdByNameUseCase(repository)
  const getSectorsWithFarm = new GetSectorsWithFarmsSectorUseCase (sectorHasFarmRepository)
  const updateFarmTimeById = new UpdateFarmTimeByIdUseCase(repository)

  return{
    add,
    show,
    del,
    edit,
    showFarmByIdUseCase,
    getSectorsWithFarm,
    updateFkEditor,
    getFarmIdByName,
    updateFarmTimeById
  }
}
